"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _RadioOption = require("./RadioOption");
/**
 * Use RadioOption instead.
 *
 * This exists for backwards compatibility only.
 *
 * @deprecated
 */
var RadioInline = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_RadioOption.RadioOption, (0, _extends2.default)({
    ref: ref
  }, props, {
    inline: true
  }));
});
exports.RadioInline = RadioInline;
RadioInline.displayName = 'RadioInline';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSYWRpb0lubGluZSIsIlJlYWN0IiwiZm9yd2FyZFJlZiIsInByb3BzIiwicmVmIiwiZGlzcGxheU5hbWUiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9SYWRpby9SYWRpb0lubGluZS5qc3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgUmFkaW9PcHRpb24gfSBmcm9tICcuL1JhZGlvT3B0aW9uJztcblxuLyoqXG4gKiBVc2UgUmFkaW9PcHRpb24gaW5zdGVhZC5cbiAqXG4gKiBUaGlzIGV4aXN0cyBmb3IgYmFja3dhcmRzIGNvbXBhdGliaWxpdHkgb25seS5cbiAqXG4gKiBAZGVwcmVjYXRlZFxuICovXG5leHBvcnQgY29uc3QgUmFkaW9JbmxpbmUgPSBSZWFjdC5mb3J3YXJkUmVmKChwcm9wcywgcmVmKSA9PiAoXG4gIDxSYWRpb09wdGlvbiByZWY9e3JlZn0gey4uLnByb3BzfSBpbmxpbmUgLz5cbikpO1xuXG5SYWRpb0lubGluZS5kaXNwbGF5TmFtZSA9ICdSYWRpb0lubGluZSc7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7QUFFQTtBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ08sSUFBTUEsV0FBVyxnQkFBR0MsY0FBSyxDQUFDQyxVQUFVLENBQUMsVUFBQ0MsS0FBSyxFQUFFQyxHQUFHO0VBQUEsb0JBQ3JELDZCQUFDLHdCQUFXO0lBQUMsR0FBRyxFQUFFQTtFQUFJLEdBQUtELEtBQUs7SUFBRSxNQUFNO0VBQUEsR0FBRztBQUFBLENBQzVDLENBQUM7QUFBQztBQUVISCxXQUFXLENBQUNLLFdBQVcsR0FBRyxhQUFhIn0=